
  import React from "react"
  import Component from "/home/vsts/work/1/s/src/layouts/index.js"
  import data from "/home/vsts/work/1/s/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js